import React from "react";
import { Form } from "react-bootstrap";
import { Season } from "../../../../types/model";
import { RootState } from "../../../../store/store";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setSelectedSeason } from "../../../../store/slices/fantasySlice";
import { FaCaretDown } from "react-icons/fa";

const SeasonFilter = () => {
	const { selectedSeason, seasons } = useAppSelector(
		(state: RootState) => state.fantasy,
	);

	const dispatch = useAppDispatch();

	const handleSeasonChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const season = event.target.value;
		const _selectedSeason = seasons.find((s: Season) => s._id === season);
		if (!_selectedSeason) {
			return;
		}
		dispatch(setSelectedSeason(_selectedSeason));
	};

	return (
		<div className="fantasy-filter-select-wrap">
			<Form.Group className="mx-sm-2 rounded-pill">
				<Form.Select
					value={selectedSeason._id}
					onChange={handleSeasonChange}
					className="fantasy-filter-select"
				>
					<option value="" disabled>
						-- Select a Season --
					</option>
					{seasons.map((season: Season) => (
						<option key={season._id} value={season._id}>
							{season.name.toLocaleUpperCase()}
						</option>
					))}
				</Form.Select>
			</Form.Group>
			<FaCaretDown className="fantasy-filter-select-icon" />
		</div>
	);
};

export default SeasonFilter;
